import parse from 'html-react-parser';
import React from 'react';
import './DokanTableItemPrice.css';

const DokanTableItemPrice = ({ styleClasses, children }) => (
    <p className={`text-sm text-primary font-semibold ${styleClasses}`}>{parse(children)}</p>
);

export default DokanTableItemPrice;
